<template>
    <div>
        <div v-if="loading_page === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <div class="mt-1" v-else>
             <v-slide-x-reverse-transition>
                <v-alert type="error" class="alert_all_page" v-if="alert_error === true">{{ alert_message_error }}</v-alert>
                <v-alert type="success" class="alert_all_page" v-if="alert_success === true">{{ alert_message_success }}</v-alert>
            </v-slide-x-reverse-transition>
            <v-row >
                <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
                    <div class="title_page ma-3">
                    <h4 class="breadcrumb_title_page">รายการใบเสร็จที่ถูกพักไว้</h4>
                    <v-breadcrumbs :items="sub_menu">
                        <template v-slot:divider>
                        <v-icon>mdi-chevron-right</v-icon>
                        </template>
                    </v-breadcrumbs>
                    </div>
                </v-col>
                <v-col xs="12" sm="12" md="4" lg="2" xl="2" cols="12">
                    <div class="title_page ma-3">
                        <v-btn type="button" class="btn_back_page" elevation="4" @click="$router.back()" large>ย้อนกลับ</v-btn>
                    </div>
                </v-col>
            </v-row>
            <div class="mt-1">
                <v-card elevation="3" class="pa-4" style="border-radius: 15px;">
                    <section class="d-flex justify-space-between">
                        <v-row>
                                <v-col xs="6" sm="6" md="9" lg="9" xl="9" cols="6" class="content-header-title mt-8">
                                     <v-btn @click="delete_all = true" outlined color="error"><v-icon>mdi-trash-can</v-icon> ยกเลิกใบเสร็จทั้งหมด</v-btn>
                            </v-col>
                            <v-col xs="6" sm="6" md="3" lg="3" xl="3" cols="6">
                                <div class="mt-1">
                                    <v-text-field color="#D6BFAF" class="input-radius" append-icon="mdi-magnify" hide-details="auto" required v-model="search" placeholder="ค้นหา..." outlined dense></v-text-field>
                                </div>
                            </v-col>
                        </v-row>
                    </section>

                    <section class="pa-3">
                        <v-data-table :headers="headers" :items="data_list" :search="search" :footer-props="footer_Props" mobile-breakpoint="0" >
                        <template v-slot:item="dataDetail">
                            <tr>
                                <td>
                                    <div class="font-16">{{dataDetail.item.invoice_code}}</div>
                                </td>
                                <td>
                                    <div v-if="dataDetail.item.created_at != null" class="font-16">{{`${dataDetail.item.created_at.split('-')[2].split(' ')[0]}/${dataDetail.item.created_at.split('-')[1]}/${dataDetail.item.created_at.split('-')[0]} ${dataDetail.item.created_at.split('-')[2].split(' ')[1]}`}}</div>
                                    <div v-else class="font-16">-</div>
                                </td>
                                <td>
                                    <div class="font-16">{{dataDetail.item.qty}}</div>
                                </td>
                                <td>
                                    <div class="font-16">{{formatPrice(dataDetail.item.total)}}</div>
                                </td>
                                <td>
                                    <div class="font-16">{{dataDetail.item.member_name ? dataDetail.item.member_name : '-'}}</div>
                                </td>
                                <td>
                                    <div class="d-flex">
                                            <span>
                                                <v-btn elevation="2" class="my-3 mx-2 font-16" outlined color="#8EBBDC" title="พิมพ์"
                                                    style="border-radius:10px" @click="getDetail(dataDetail.item.id), this.dialog_detail = true" >
                                                    <v-icon>mdi-magnify</v-icon>
                                                </v-btn>
                                            </span>  
                                            <span>
                                                <v-btn elevation="2" class="my-3 font-16" outlined color="error" title="ดูรายละเอียด"
                                                    style="border-radius:10px" @click="removeBill(dataDetail.item.id)">
                                                    <v-icon>mdi-trash-can</v-icon>
                                                </v-btn>
                                            </span>                      
                                        </div>
                                </td>
                                <td>
                                      <div class="d-flex">
                                        <span>
                                            <v-btn elevation="2" class="my-3 font-16" outlined color="#88B358" title="ดูรายละเอียด" @click="recallInvoice(dataDetail.item.id)"
                                                style="border-radius:10px" >
                                                <v-icon>mdi-currency-usd</v-icon> เรียกใช้
                                            </v-btn>
                                        </span>                      
                                    </div>
                                </td>
                            </tr>
                        </template>
                        </v-data-table>
                    </section>

                </v-card>
            </div>
             <v-dialog v-if="dialog_detail == true" v-model="dialog_detail" persistent max-width="600">
                <v-card class="input-radius">
                    <div class="d-flex justify-end">
                        <v-btn icon class="ma-4" @click="dialog_detail = false">
                            <v-icon color="grey">mdi-close</v-icon>
                        </v-btn>
                    </div>
                    <v-card-text>
                        <v-row>
                            <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                                    <p style="font-size:20px;">รายละเอียดใบเสร็จ</p>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col class="pl-5" cols="6">
                                {{detailList.invoice.invoice_code != null ? detailList.invoice.invoice_code : '-'}}
                            </v-col>
                            <v-col cols="6" class="text-right">
                                 {{detailList.invoice.created_at != null ? `${detailList.invoice.created_at.split('-')[2].split(' ')[0]}/${detailList.invoice.created_at.split('-')[1]}/${detailList.invoice.created_at.split('-')[0]} @ ${detailList.invoice.created_at.split('-')[2].split(' ')[1]}` : '-'}}
                            </v-col>
                        </v-row>
                        <v-divider class="my-3"></v-divider>

                        <v-row>
                            <v-col cols="12">
                                <v-simple-table>
                                    <thead>
                                        <th class="pl-3 text-left">Item</th>
                                        <th class="text-center">ราคา</th>
                                        <th class="text-center">จำนวน</th>
                                        <th class="text-center">รวม</th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in detailList.invoice_list" :key="item.id">
                                            <td>
                                                {{item.product_name}}
                                            </td>
                                            <td class="text-center">
                                            {{formatPrice(item.price)}}
                                            </td>
                                            <td class="text-center">
                                                {{formatPrice(item.qty)}}
                                            </td>
                                            <td class="text-center">
                                                {{formatPrice(item.total)}}
                                            </td>
                                        </tr>
                                        <tr v-for="item in detailList.invoice_list" :key="item.id" :class="parseFloat(item.discount) > 0 ? '' : 'd-none'">
                                            <td>ส่วนลด {{item.product_name}}</td>
                                            <td></td>
                                            <td></td>
                                            <td> {{formatPrice(item.discount)}}</td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-col>
                        </v-row>
                        <v-divider ></v-divider>
                        <v-row >
                            <v-col cols="8" class="pl-7 mt-4 bold">
                                ยอดสุทธิ
                            </v-col>
                            <v-col cols="2" class="text-center mt-4 pl-9 pr-0 bold">
                                {{formatPrice(total_qty)}} ชิ้น
                            </v-col>
                            <v-col cols="2" class="text-center mt-4 pl-0 bold">
                               {{formatPrice(total_price)}}
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </div>
        <v-dialog v-model="delete_all" persistent max-width="450">
            <v-card class="input-radius">
                <div class="d-flex justify-space-between">
                    <v-card-title>
                        
                    </v-card-title>
                    <v-btn icon class="ma-4" @click="delete_all = false">
                        <v-icon color="grey">mdi-close</v-icon>
                    </v-btn>
                </div>
                <v-card-text>
                    <v-row>
                        <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                            <center>
                                <v-img width="90" height="90" src="@/assets/arin_assets/warning.png"
                                    class="preview mt-3 mb-2"></v-img>
                                <h3>ยืนยันการยกเลิกบิลทั้งหมดที่พักไว้</h3>
                            </center>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pb-5">
                    <v-spacer></v-spacer>
                    <v-btn type="button" class="btn_add_data_pop" style=" background: linear-gradient(90deg, #FFFF 0%, rgba(136, 179, 88, 0) 100%), #FFFF !important;" color="error" elevation="4" outlined @click="delete_all = false"
                        large>ยกเลิก</v-btn>
                            <v-btn type="button" class="btn_add_data_pop" elevation="4" @click="removeBill_all()"
                        large>ยืนยัน</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
  
<script>
import { HTTP_ARIN } from "@/axios_arin";
import { formatPrice } from "@/js/handler";
import Swal from "sweetalert2";
export default {
    inject: {
        theme: {
            default: {
                isDark: false,
            },
        },
    },
    name: "Pos_Recall_Bill",
    data() {
        return {
            loading_page: false,
            delete_all: false,
            dialog_detail: false,
            alert_success: false,
            alert_message_success: null,
            alert_message_error: null,
            search: '',
            footer_Props:{
                'items-per-page-text':'รายการต่อหน้า'
            },
            headers:[
                { 
                    text: 'เลขที่ใบเสร็จ',
                    value: 'invoice_code',
                    fixed: true,
                    width: '120px'
                },
                { 
                    text: 'วันที่พักใบเสร็จ',
                    value: 'receipt_tax',
                    fixed: true,
                    width: '200px'
                },
                { 
                    text: 'จำนวน',
                    value: 'receipt_date',
                    fixed: true,
                    width: '120px'
                },
                { 
                    text: '',
                    value: 'receipt_date',
                    fixed: true,
                    width: '120px'
                },
                { 
                    text: 'ชื่อสมาชิก',
                    value: 'receipt_name',
                    fixed: true,
                    width: '210px'
                },
                { 
                    text: 'จัดการ',
                    value: 'receipt_price',
                    fixed: true,
                    width: '130px'
                },
                { 
                    text: 'เรียกใช้',
                    value: '',
                    fixed: true,
                    width: '120px'
                },
            ],

            data_list: [],
            sub_menu:[
                {
                    text:'ระบบ POS',
                    disabled:false,
                },
                {
                    text:'การขาย',
                    disabled:false,
                },
                {
                    text:'เรียกบิล',
                    disabled:false,
                },
            ],
            detailList: {},
            total_qty: 0,
            total_price: 0
        }
    }, methods: {
        link(link){
            window.location.href = link;
        },
        formatPrice(number){
            return formatPrice(number)
        },
        getBillRecall(){
             let config = {
                    headers: {
                        'Content-Type': 'application/json',
                        "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
                    }
                }
                let id = parseFloat(this.$route.params.id)
                HTTP_ARIN.get(`/pos/get/invoice/list/${id}?status=1`, config).then((res) => {
                    if (res.data.successful === true) {
                        this.data_list = res.data.invoiceList;
                    }
                })
        },
        removeBill(id){
             Swal.fire({
        title: 'แน่ใจใช่ไหม?',
        text: "คุณต้องการลบใบเสร็จที่พักไว้หรือไม่?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก',
      }).then((result => {
        if(result.isConfirmed){
            let config = {
                    headers: {
                        'Content-Type': 'application/json',
                        "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
                    }
                }
                HTTP_ARIN.get(`/pos/clear/invoice/one/${id}`, config).then((res) => {
                    if (res.data.successful === true) {
                        this.getBillRecall()
                         this.alert_success = true
                        this.alert_message_success = 'ยกเลิกพักบิลเรียบร้อยแล้ว'
                        setTimeout(() => this.alert_success = false, 5000)
                    }
                })
        }
      }))
        },
        removeBill_recall(id){
            let config = {
                    headers: {
                        'Content-Type': 'application/json',
                        "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
                    }
                }
                HTTP_ARIN.get(`/pos/clear/invoice/one/${id}`, config).then((res) => {
                    if (res.data.successful === true) {
                        this.getBillRecall()
                         this.alert_success = true
                        this.alert_message_success = 'ยกเลิกพักบิลเรียบร้อยแล้ว'
                        setTimeout(() => this.alert_success = false, 5000)
                    }
                })
        },
        removeBill_all(){
            let config = {
                    headers: {
                        'Content-Type': 'application/json',
                        "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
                    }
                }
                let id = this.$route.params.id;
                HTTP_ARIN.get(`/pos/clear/invoice/${id}`, config).then((res) => {
                    if (res.data.successful === true) {
                        this.getBillRecall()
                        this.delete_all = false;
                        this.alert_success = true
                        this.alert_message_success = 'ยกเลิกพักบิลทั้งหมดเรียบร้อยแล้ว'
                        setTimeout(() => this.alert_success = false, 5000)
                    }
                })
        },
       async getDetail(id){
        this.total_qty = 0
        this.total_price = 0
            let config = {
                    headers: {
                        'Content-Type': 'application/json',
                        "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
                    }
                }
               await HTTP_ARIN.get(`/pos/invoice/detail/${id}`, config).then((res) => {
                    if (res.data.successful === true) {
                        this.detailList = res.data.data
                         this.detailList.invoice_list.forEach((detail) => {
                          this.total_qty += parseFloat(detail.qty)
                          this.total_price += parseFloat(detail.total)
                        })
                        this.dialog_detail = true
                    }
                })
        },
       async recallInvoice(id){
           let config = {
                    headers: {
                        'Content-Type': 'application/json',
                        "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
                    }
                }
               await HTTP_ARIN.get(`/pos/invoice/detail/${id}`, config).then((res) => {
                    if (res.data.successful === true) {
                         this.detailList = res.data.data
                       let data =  {
                invoice: {
                    id: this.detailList.invoice.id,
                    customer_id: this.detailList.invoice.customer_id,
                    round_total_invoice_id: this.detailList.invoice.round_total_invoice_id,
                    cost: this.detailList.invoice.cost,
                    vat: this.detailList.invoice.vat,
                    total: this.detailList.invoice.total,
                    discount: this.detailList.invoice.discount,
                    pay_type: this.detailList.invoice.pay_type,
                    cash: this.detailList.invoice.cash,
                    payment: this.detailList.invoice.payment,
                    credit_id: this.detailList.invoice.credit_id,
                    credit: this.detailList.invoice.credit,
                    etc_payment: this.detailList.invoice.etc_payment,
                    qrcode_pay: this.detailList.invoice.qrcode_pay,
                    use_point: this.detailList.invoice.use_point,
                    point: this.detailList.invoice.point,
                    pay: this.detailList.invoice.pay,
                    change: this.detailList.invoice.change,
                    status: this.detailList.invoice.status,
                    user_create: this.detailList.invoice.user_create,
                    invoice_code: this.detailList.invoice.invoice_code,
                    member_name: this.detailList.invoice.member_name,
                    tel_number: this.detailList.invoice.tel_number
                },
                invoice_list: this.detailList.invoice_list,
            };
            this.$store.commit('getInvoice',data)
            this.$router.push('/arin/pos/openpos')
            this.removeBill_recall(this.detailList.invoice.id)
                    }
                })
        }
    },
    mounted(){
       this.getBillRecall()
    }
}
</script>
  
<style scoped>
.btn_add_data {
  font-size: 16px;
  color: #FFF;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
  border-radius: 10px;
  /* width: 200px; */
}
.btn_add_data_pop {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 135px !important;
}
</style>
  